<ng-template appChildEntityDisplayHost></ng-template>
